//
//
//
//
import effectScatter from '@/components/bigDataChart/effectScatter';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'servicePopulation',
  created: function created() {
    this.queryWaterType();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    dataMap: {
      type: Object,
      default: {}
    }
  },
  components: {
    effectScatter: effectScatter
  },
  methods: {
    queryWaterType: function queryWaterType(areaId, projectId) {
      var _this = this;

      setTimeout(function () {
        var datalist = [{
          offset: [20, 30],
          symbolSize: 85,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#29c0fb'
          }, {
            offset: 1,
            color: '#2dc5b9'
          }])
        }, {
          offset: [75, 75],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#29c0fb'
          }, {
            offset: 1,
            color: '#2dc5b9'
          }])
        }, {
          offset: [90, 50],
          symbolSize: 30,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#29c0fb'
          }, {
            offset: 1,
            color: '#2dc5b9'
          }])
        }, {
          offset: [20, 75],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#35d17e'
          }, {
            offset: 1,
            color: '#49ddb2'
          }])
        }, {
          offset: [60, 28],
          symbolSize: 80,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#e5d273'
          }, {
            offset: 1,
            color: '#e4a37f'
          }])
        }];
        var data = [{
          name: '河埠头浊度',
          value: _this.dataMap['u10302'].value + " NTU"
        }, {
          name: '泵站前水位',
          value: _this.dataMap['u21901'].value + " m"
        }, {
          name: '隧洞前水位',
          value: _this.dataMap['u22001'].value + " m"
        }, {
          name: '原水水位',
          value: _this.dataMap['u22101'].value + " m"
        }, {
          name: '流量',
          value: _this.dataMap['u20201'].value + " m³/s"
        }];

        _this.$refs.chart1.initEffectScatterChart(data, datalist);
      }, 1000);
    }
  }
};